import { HelpShortcutCard } from './HelpShortcutCard';
import type { HelpShortcut } from '../types';

type HelpShortcutGridProps = {
    shortcuts: HelpShortcut[];
};

export function HelpShortcutGrid({ shortcuts }: HelpShortcutGridProps) {
    return (
        <div className="grid gap-3 md:grid-cols-2">
            {shortcuts.map((shortcut) => (
                <HelpShortcutCard key={shortcut.id} shortcut={shortcut} />
            ))}
        </div>
    );
}
